const FREE_PLAN_SLUG = 'free';

export interface SubscriptionPlanLike {
  slug?: string | null;
  value?: number | string | null;
  value_yearly?: number | string | null;
}

export interface SubscriptionLike {
  plan?: SubscriptionPlanLike | null;
  // Present on the myData subscription JSON but deliberately ignored —
  // churned users downgraded to the free plan keep these set.
  payment_provider?: string | null;
  stripe_subscription_id?: string | null;
  store_product_id?: string | null;
}

/**
 * Whether a subscription should get paid-tier treatment in the UI.
 *
 * A plan counts as paid when any of its price fields is positive, or when
 * it is a custom non-free plan (hidden plans assigned manually often have
 * their price fields left at 0/null, e.g. comped or custom-priced Stripe
 * subscriptions). Payment provider fields are deliberately ignored: churned
 * users downgraded to the free plan keep them set.
 */
export function isPaidSubscription(
  subscription: SubscriptionLike | null | undefined,
): boolean {
  const plan = subscription?.plan;
  if (!plan) return false;
  if (Number(plan.value ?? 0) > 0) return true;
  if (Number(plan.value_yearly ?? 0) > 0) return true;
  return plan.slug != null && plan.slug !== FREE_PLAN_SLUG;
}
